export function clearError(errors, field) {
  if (!errors[field]) return errors;

  const { [field]: _, ...rest } = errors;
  return rest;
}
